
<template>
  <div>
    <base-card :with_title="false">
      <template v-slot:content>
        <div v-if="!loading && templates.length">
          <templates-small-card v-for="project in templates" :key="project.id" :project="project" class="my-2" @click="handleClickTemplate(project)"></templates-small-card>
        </div>
        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <div v-if="!loading && !templates.length">
          {{ $t('templates.none') }}
        </div>
      </template>
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';
import TemplateSmallCard from '../shared/TemplateSmallCard.vue';

export default {
  name: 'TemplateList',
  //mixins: [ validations ],
  components: {
    TemplatesSmallCard: TemplateSmallCard
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      templates: [],
    }
  },
  methods: {
    getProjecTemplates() {
      this.loading = true
      Api.Project.index({use_type: ['template']}).then(r=> r.data).then(d => {
        this.templates = [...d]
      }).finally(()=> {
        this.loading = false
      })
    },
    handleClickTemplate(project){
      console.log({project});
      this.$router.push({name: 'OneTemplate', params: {id: project.id}})
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.getProjecTemplates()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    '$route'() {
      this.getProjecTemplates()
    }
  },
}
</script>

<style scoped>

</style>